import axios from "axios";
import constants from "./constants";

export function defaultGet(apiName, success, failure, isCustom) {
    var fullMethodUrl = (isCustom ? constants.baseApiUrl : constants.ctsApiUrl) + apiName;

    axios.get(fullMethodUrl, { headers: constants.headers })
        .then((res) => success(res))
        .catch((err) => failure(err));
}

export function defaultPost(apiName, body, success, failure, isCustom) {
    var fullMethodUrl = (isCustom ? constants.baseApiUrl : constants.ctsApiUrl) + apiName;

    axios.post(fullMethodUrl, body, { headers: constants.headers })
        .then((res) => success(res))
        .catch((err) => failure(err));
}

export function CapitalizeFirstLetter(str) {
    if (str == null || str == undefined || str == "")
        return ""

    try {
        const words = str.trim().split(" ");
        var retVal = words[0][0] + words[words.length - 1][0];
        return retVal.toUpperCase();
    }
    catch (err) { console.log(err) }
}

export function alertMessage(message) {
    alert(message)
}
export function DownloadFileWithoutName(getRequestUrl) {
  const req = new XMLHttpRequest();
  req.open("GET", getRequestUrl, true);
  req.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("user"));
  req.responseType = "blob";

  req.onload = function () {
    if (this.status === 204) {
      const strURL = getRequestUrl.toString();
      if (strURL.toLowerCase().includes("with")) {
        window.showAlert("res_Msgs_ThereIsNoAttachment", "warning");
      } else {
        window.showAlert("res_Msgs_UnableToDownload", "warning");
      }
      return;
    }

    if (this.status === 500) {
      window.showAlert("res_Msgs_UnableToDownload", "warning");
      return;
    }

    // ✅ Extract filename from Content-Disposition header
    let fileName = "downloaded_file";
    const disposition = req.getResponseHeader("Content-Disposition");
    if (disposition && disposition.indexOf("filename=") !== -1) {
      const fileNameMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (fileNameMatch && fileNameMatch[1]) {
        fileName = decodeURIComponent(fileNameMatch[1].replace(/['"]/g, ""));
      }
    }

    // Convert the byte data to a Blob
    const blob = new Blob([req.response], { type: req.getResponseHeader("Content-Type") || "application/octet-stream" });

    const isIE = !!document.documentMode;
    if (isIE) {
      window.navigator.msSaveBlob(blob, fileName);
    } else {
      const url = window.URL || window.webkitURL;
      const link = url.createObjectURL(blob);
      const a = document.createElement("a");
      a.setAttribute("download", fileName);
      a.setAttribute("href", link);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(link);
    }

    window.showAlert("res_Msgs_AttachmentDownloaded", "success");
  };

  req.send();
}

export function DownloadFile(getRequestUrl, fileName) {
    var req = new XMLHttpRequest();
    req.open("GET", getRequestUrl, true);
    req.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem('user'));
    req.responseType = "blob";
    req.onload = function () {
        if (this.status === 204) {
            var strURL = getRequestUrl.toString();
            if (strURL.toLowerCase().includes("with")) {
                window.showAlert("res_Msgs_ThereIsNoAttachment", "warning")
            }
            else {
                window.showAlert("res_Msgs_UnableToDownload", "warning")
            }
            return
        }

        if (this.status === 500) {
            window.showAlert("res_Msgs_UnableToDownload", "warning")
            return
        }

        //Convert the Byte Data to BLOB object.
        var blob = new Blob([req.response], { type: "application/octetstream" });
        //Check the Browser type and download the File.

        var isIE = false || !!document.documentMode;
        if (isIE) {
            window.navigator.msSaveBlob(blob, fileName);
        }
        else {
            var url = window.URL || window.webkitURL;
            var link = url.createObjectURL(blob);
            var a = document.createElement("a");
            a.setAttribute("download", fileName);
            a.setAttribute("href", link);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }

        window.showAlert('res_Msgs_AttachmentDownloaded', 'success')
    };
    req.send();
}

export function PrintFile(getRequestUrl, fileName) {
    var req = new XMLHttpRequest();
    req.open("GET", getRequestUrl, true);
    req.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem('user'));
    req.responseType = "blob";
    req.onload = function () {
        if (this.status === 204) {
            var strURL = getRequestUrl.toString();
            if (strURL.includes("with")) {
                window.showAlert("There is no letter/attachment for the selected correspondence", "warning")
            }
            else {
                window.showAlert("Unable to print for the selected correspondence", "warning")
            }

            return
        }

        var blob = new Blob([req.response], { type: "application/pdf" });
        var blobURL = URL.createObjectURL(blob);

        var iframe = document.createElement('iframe'); //load content in an iframe to print later
        document.body.appendChild(iframe);

        iframe.style.display = 'none';
        iframe.src = blobURL;
        iframe.onload = function () {
            setTimeout(function () {
                iframe.focus();
                iframe.contentWindow.print();
            }, 1);
        };
    };
    req.send();
}

export function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function CheckIfNullOrEmpty(value) {
    if (value == null || value == undefined || value == {} || value == "" || value == "null")
        return true;
    else
        return false;
}

export function GetMultiSelectSubHeaderDisplay(options) {
    var retVal = '';
    if (options.isUser) {
        retVal = options.profession + ' - ' + (options.parentName ? options.parentName : '') + ' ( ' + (options.companyName ? options.companyName : '') + ' )'
    }
    else {
        if (options.parentName != null && options.companyName != null)
            retVal = options.parentName + ' ( ' + options.companyName + ' )'
    }

    return retVal;
}

export function GetDateOnly(strDateTime) {
    if (strDateTime == null || strDateTime == undefined || strDateTime == "")
        return ""

    var date = new Date(strDateTime)
    var day = date.getDate()
    var month = date.getMonth() + 1
    var year = date.getFullYear()

    // convert month to 2 digits
    if (month < 10)
        month = '0' + month

    return year + '-' + month + '-' + day
}

export function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

const overDueStatus = {
    emtpyStatus: 1,
    today: 2,
    nearDue: 3,
    overDue: 4
};

export function getOverDueByNode(overdue, nodeId) {
    var overDueByNode = overDueStatus.emtpyStatus;

    if (overdue == '' || nodeId == 1 || nodeId == 8) {
        overDueByNode = overDueStatus.emtpyStatus;
    }
    else {
        if (overdue == "today")
            overDueByNode = overDueStatus.today
        else if (overdue == "overdue")
            overDueByNode = overDueStatus.overDue
        else if (overdue == "neardue")
            overDueByNode = overDueStatus.nearDue
    }

    return overDueByNode;
}
export function getOverDue(overdue, nodeId) {
    var overDueIcon = ''
    var overDueByNode = this.getOverDueByNode(overdue, nodeId);

    switch (overDueByNode) {
        case overDueStatus.emtpyStatus: overDueIcon = ''; break;
        case overDueStatus.today: overDueIcon = 'mdi-clock'; break;
        case overDueStatus.nearDue: overDueIcon = 'mdi-clock'; break;
        case overDueStatus.overDue: overDueIcon = 'mdi-overdue'; break;
        default: overDueIcon = ''; break;
    }

    return overDueIcon;
}

export function getOverdueDays(overdue, overdueDays, nodeId) {
    var overdueResult = '';
    var overDueByNode = this.getOverDueByNode(overdue, nodeId);

    switch (overDueByNode) {
        case overDueStatus.emtpyStatus: overdueResult = ''; break;
        case overDueStatus.today: overdueResult = window.translate('res_Label_Today'); break;
        case overDueStatus.nearDue:
            overdueResult = Math.abs(parseInt(overdueDays)) == 1 ? + Math.abs(parseInt(overdueDays)) + ' ' + window.translate('res_Label_Day')
                : Math.abs(parseInt(overdueDays)) + ' ' + window.translate('res_Label_Days'); break;
        case overDueStatus.overDue: overdueResult = window.translate('res_Label_Overdue'); break;
        default: overdueResult = ''; break;
    }

    return overdueResult
}

export function getPriorityClassColor(priorityId) {
    switch (priorityId) {
        case 1: return ''; break;
        case 2: return 'text-warning'; break;
        case 3: return 'text-danger'; break;
    }

    return '';
}

export function getPriorityName(id) {
    var priority = constants.priorities.find(x => x.id == id);
    if (priority != null) {
        return priority.name
    }
    else {
        return ''
    }
}

export function getStatusClass(id) {
    var status = constants.statuses.find(x => x.id == id)
    if (status != null)
        return status.classColor.toLowerCase().replace(" ", "_")
    else
        return ''
}

export function getStatus(id) {
    debugger
    var status = constants.statuses.find(x => x.id == id)
    if (status != null)
        return status.key
    else
        return ''
}

export function formatDateTime(datetime) {
    try {
        if (datetime == null || datetime == undefined || datetime == "")
            return ""
        const parts = datetime.replace('T', ' ').split(" ");
        const dateParts = parts[0].split("-");
        const year = dateParts[0].substring(2);
        const month = dateParts[1];
        const day = dateParts[2];
        const formattedDate = `${day}/${month}/${year}`;
        return formattedDate;
    }
    catch (e) {
        return datetime;
    }
}

export function formatDateTimeWithTime(datetime) {
    try {
        if (datetime == null || datetime == undefined || datetime == "")
            return ""

        const [datePart, timePart] = datetime.split("T");
        const [hours, minutes] = timePart.split(":");

        const dateParts = datePart.split("-");
        const formattedDate = dateParts[2] + '/' + dateParts[1] + '/' + dateParts[0].substring(2) + ' '
            + hours + ':' + minutes;

        return formattedDate;
    }
    catch (e) {
        return datetime;
    }
}

export function dateFormat(inputDate, format, includeTime) {
    if (inputDate == null || inputDate == undefined || inputDate == "") {
        return ""
    }

    if (!format)
        format = 'dd/MM/yyyy'

    if (includeTime)
        format = format + " hh:mm:ss"

    if (inputDate != null && inputDate != undefined && inputDate != '') {
        const date = new Date(inputDate);

        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        format = format.replace("MM", month.toString().padStart(2, "0"));

        if (format.indexOf("yyyy") > -1) {
            format = format.replace("yyyy", year.toString());
        } else if (format.indexOf("yy") > -1) {
            format = format.replace("yy", year.toString().substr(2, 2));
        }

        format = format.replace("dd", day.toString().padStart(2, "0"));

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        if (format.indexOf("hh") > -1) {
            format = format.replace("hh", hours.toString());
        }
        if (format.indexOf("mm") > -1) {
            format = format.replace("mm", minutes.toString());
        }
        if (format.indexOf("ss") > -1) {
            format = format.replace("ss", seconds.toString());
        }
        return format;
    }
}

export function formatDateFromString(date) {
    return new Date(date);
}

export const applyDrag = (arr, dragResult) => {
    const { removedIndex, addedIndex, payload } = dragResult
    if (removedIndex === null && addedIndex === null) return arr

    const result = [...arr]
    let itemToAdd = payload

    if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
    }

    if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
    }

    return result
}

export function GetTranslatedValue(enVal, arVal) {
    var val = enVal;
    if (localStorage.getItem('lang') == 'ar' && arVal) {
        val = arVal
    }

    return val;
}

export function copyObject(sourceObject, targetObject) {
    for (const key in sourceObject) {
        targetObject[key] = sourceObject[key];
    }

    return targetObject;
}


export function SwitchByLang(englishResource = "", arabicResource = "", lang = "") {
    var language = 'ar';
    if (lang.trim() != "" && (lang == 'en' || lang == 'ar'))
        language = lang;
    else if (localStorage.getItem('lang') != null)
        language = localStorage.getItem('lang');

    var isEnglishResourceHasValue = false;
    var isArabicResourceHasValue = false;

    isEnglishResourceHasValue = englishResource !== "" && englishResource !== null && englishResource !== undefined && englishResource.trim() !== '';
    isArabicResourceHasValue = arabicResource !== "" && arabicResource !== null && arabicResource !== undefined && arabicResource.trim() !== '';

    if (language === 'en' && isEnglishResourceHasValue)
        return englishResource;
    else if (language === 'ar' && isArabicResourceHasValue)
        return arabicResource;
    else if (isEnglishResourceHasValue)
        return englishResource;
    else if (isArabicResourceHasValue)
        return arabicResource;
    else
        return "";
}

export function handleFirstElement(data, tempItem) {

    if (data.length > 0) {
        var shouldAddTemp = true;
        for (var i = 0; i < data.length; i++) {
            if (data[i].isTemp
                || data[i].id == undefined
                || data[i].id == null
                || data[i].id == -1) {
                shouldAddTemp = false;
                break;
            }
        }

        if (shouldAddTemp) {
            if (tempItem == undefined || tempItem == null) {
                tempItem = { isTemp: true, name: 'temp' };
            }
            data = [tempItem, ...data];
        } else if (data.length == 1) {
            data = [];
        }
    }
    return data;
}

export function isArabicText(text) {
    var arregex = /[\u0600-\u06FF]/;
    return arregex.test(text);
}

export function validateTowDate(startDate, endDate) {

    var res = new Date(endDate) - new Date(startDate);
    if (res >= 0)
        return true;
    return false;
}
export function generateGUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0; // random number between 0 and 15
      const v = c === "x" ? r : (r & 0x3) | 0x8; // for 'y', make sure the first 2 bits are 10
      return v.toString(16);
    });
}
export function DownloadMultipleZipped(postRequestUrl, attachmentIds, blobType) {
    if (!blobType) {
        blobType = "application/zip";
    }

    var req = new XMLHttpRequest();
    req.open("POST", postRequestUrl, true);
    req.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem('user'));
    req.setRequestHeader("Content-Type", "application/json");
    req.responseType = "blob"; 
    req.onload = function () {
        if (this.status === 204) {
            var strURL = getRequestUrl.toString();
            if (strURL.toLowerCase().includes("with")) {
                window.showAlert("res_Msgs_ThereIsNoAttachment", "warning")
            }
            else {
                window.showAlert("res_Msgs_UnableToDownload", "warning")
            }
            return;
        }

        if (this.status === 500) {
            window.showAlert("res_Msgs_UnableToDownload", "warning")
            return;
        }
        
        var contentDisposition = req.getResponseHeader("Content-Disposition");
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const minutes = String(currentDate.getMinutes()).padStart(2, '0');
        const seconds = String(currentDate.getSeconds()).padStart(2, '0');
        
        const fileName = `attachments_${year}/${month}/${day}/${minutes}${seconds}`;

        if (contentDisposition && contentDisposition.includes("filename=")) {
            fileName = contentDisposition
                .split("filename=")[1]
                .replace(/['"]/g, '');
        }

        var blob = new Blob([this.response], { type: blobType });

        var isIE = false || !!document.documentMode;
        if (isIE) {
            window.navigator.msSaveBlob(blob, fileName);
        } else {
            var url = window.URL || window.webkitURL;
            var link = url.createObjectURL(blob);
            var a = document.createElement("a");
            a.setAttribute("download", fileName);
            a.setAttribute("href", link);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            url.revokeObjectURL(link); 
        }

        window.showAlert('res_Msgs_AttachmentDownloaded', 'success');
    };

    req.onerror = function () {
        window.showAlert("res_Msgs_UnableToDownload", "warning");
    };

    req.send(JSON.stringify(attachmentIds));
}

  
  